"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var columnChart_styles_1 = require("./columnChart.styles");
var core_components_1 = require("@securityproducts/core-components");
function ColumnChart(props) {
    var firstHeight = props.firstValue === 0 ? 0 : (props.firstValue / (props.maxValue * 1.2)) * 100 + "%";
    var secondHeight = props.secondValue === 0 ? 0 : (props.secondValue / (props.maxValue * 1.2)) * 100 + "%";
    var minutesAndSecondsFirst = core_components_1.hoursMinutesSeconds(props.firstValue, props.language);
    var minutesAndSecondsSecond = core_components_1.hoursMinutesSeconds(props.secondValue, props.language);
    var columnSwitch = props.single ? columnChart_styles_1.singleColumn : columnChart_styles_1.column;
    var firstColumnSwitch = props.single ? columnChart_styles_1.firstColumnSingle : columnChart_styles_1.firstColumn;
    return (React.createElement("div", { className: columnChart_styles_1.container, style: { width: props.width }, id: props.id },
        props.showYAxis && React.createElement("div", { className: columnChart_styles_1.yAxis }, "DURATION"),
        React.createElement("div", { className: columnChart_styles_1.container },
            React.createElement("div", { className: columnChart_styles_1.lineOne }),
            React.createElement("div", { className: columnChart_styles_1.lineTwo }),
            React.createElement("div", { className: columnChart_styles_1.lineThree }),
            React.createElement("div", { className: columnChart_styles_1.lineFour }),
            React.createElement("div", { className: columnSwitch + " " + firstColumnSwitch, style: { height: firstHeight }, id: props.id + "-average-column" },
                React.createElement("div", { className: columnChart_styles_1.valueLabel, id: props.id + "-average-column-label" }, minutesAndSecondsFirst)),
            React.createElement("div", { className: columnSwitch + " " + columnChart_styles_1.secondColumn, style: { height: secondHeight }, id: props.id + "-max-column" },
                React.createElement("div", { className: columnChart_styles_1.valueLabel, id: props.id + "-max-column-label" }, minutesAndSecondsSecond))),
        React.createElement("div", { className: columnChart_styles_1.label, id: props.id + "-x-axis" }, props.xAxis)));
}
exports.ColumnChart = ColumnChart;
